import { C } from "./theme";

// Named hues for tiles and labels: c is the colour itself, w its wash, b its border.
// Read at render time: C changes with the theme.
export const hue = (name) => ({
  purple: { c: C.purple, w: C.purpleBg, b: C.purpleLight },
  amber:  { c: C.amber,  w: C.amberBg,  b: C.amberLight },
  orange: { c: C.orange, w: C.orangeBg, b: C.orangeLight },
  teal:   { c: C.teal,   w: C.tealBg,   b: C.tealLight },
  blue:   { c: C.blue,   w: C.blueBg,   b: C.blueLight },
  cyan:   { c: C.cyan,   w: C.cyanBg,   b: C.cyanLight },
  red:    { c: C.red,    w: C.redBg,    b: C.redLight },
  pink:   { c: C.pink,   w: C.pinkBg,   b: C.pinkLight },
  lime:   { c: C.lime,   w: C.limeBg,   b: C.limeLight },
  gold:   { c: C.gold,   w: C.goldBg,   b: C.goldLight },
  forest: { c: C.forest, w: C.forestBg, b: C.forestLight },
  // Solid wash and border (the teal tokens): the translucent accent tints mix to grey.
  green:  { c: C.accent, w: C.tealBg, b: C.tealLight },
  grey:   { c: C.textMid, w: C.surface, b: C.border },
})[name];
